import template from './bf-ebay-connection-assistant-logo.html.twig';
import './bf-ebay-connection-assistant-logo.scss';

Shopware.Component.register('bf-ebay-connection-assistant-logo', {
    template
});
